export enum SegmentModalScreenNames {
  Withdraw = 'withdraw_to_bank',
  AddCardDetails = 'add_credit_card_details',
  AddStripeDetails = 'add_stripe_details',
  MFA = 'mfa',
  MFASuccess = 'mfa_success',
  MFAFailure = 'mfa_failure',
  MFASetup = 'mfa_setup',
  MFASetupOktaVerify = 'mfa_setup_okta_verify',
  MFAResetPinCode = 'mfa_reset_pin_code',
  MFAUpdatePinCode = 'mfa_update_pin_code',
  EnableAutoPay = 'enable_autopay',
  EditRecipient = 'edit_recipient_address_book',
  linkBankAccount = 'link_bank_account',
  NoLinkedBankAccounts = 'no_linked_bank_accounts_step',
  setBankAccountNickname = 'set_bank_account_nickname',
  ChooseDepositType = 'deposit_method',
  ChooseTransferType = 'transfer_method',
  TestWireTransfer = 'deposit_wire_step_0',
  WireTransferSelectBankAccount = 'deposit_wire_step_1',
  WireTransferSelectCurrency = 'deposit_wire_select_currency_step',
  WireTransferBeneficiaryBankAccount = 'deposit_wire_step_3',
  WireTransferDisclosures = 'deposit_wire_step_4',
  WalletTransferChooseBlockchain = 'deposit_blockchain_step_1',
  WalletTransferBlockchainTransferInstruction = 'deposit_blockchain_step_2',
  WalletTransferBlockchainChooseRecipient = 'deposit_ace_blockchain_step_2',
  WalletTransferBlockchainSelectAmount = 'deposit_ace_blockchain_step_3',
  WalletTransferBlockchainCompleteDeposit = 'deposit_ace_blockchain_step_4',
  WalletTransferBlockchainDepositSuccess = 'deposit_ace_blockchain_step_5',
  IpAllowlistingToggleSetting = 'ip_allowlisting_toggle_setting',
  PayInvoiceSelectPaymentMethod = 'pay_invoice_step_1',
  PayInvoiceConfirmPayment = 'pay_invoice_step_2',
  PeriodicReviewTakeover = 'periodic_review_takeover',
  PinCodeTakeover = 'pin_code_takeover',
  AdminApprovalsSettings = 'admin_approvals_settings',
  IpAllowlistingIpAddressRemove = 'ip_allowlisting_ip_address_remove',
  IpAllowlistingIpAddressCreate = 'ip_allowlisting_ip_address_create',
  DelayedWithdrawalsToggleSetting = 'delayed_withdrawals_toggle_setting',
  IpAllowlistingIpAddressEmpty = 'ip_allowlisting_ip_address_empty',
  CancelUserApprovalRequest = 'cancel_user_approval_request',
  UserRemove = 'user_remove',
  UserRemoveWithAdminApproval = 'user_remove_with_admin_approval',
  UserResendInvite = 'user_resend_invite',
  UserChangePasswordError = 'user_change_password_error',
  UserChangePasswordSuccess = 'user_change_password_success',
  AddressBookVerifyAddressOwnerType = 'address_book_add_address_verify_address_owner_type',
  AddressBookSelectRecipient = 'address_book_add_address_select_recipient',
  AddressBookCustomer = 'address_book_add_address_customer',
  AddressBookNonCustomer = 'address_book_add_address_non_customer',
  AddressBookBeneficiaryInfo = 'address_book_add_address_beneficiary_info',
  AddressBookAdditionalWalletInfo = 'address_book_add_address_additional_wallet_info',
  AddressBookSuccess = 'address_book_add_address_success',
  AddressBookRemoveAddressConfirmation = 'address_book_remove_address_confirmation',
  WalletApprovalPolicyPermissions = 'wallet_approval_policy_permissions',
  WalletApprovalPolicyLimitsPolicy = 'wallet_approval_policy_limits_policy',
  WalletApprovalPolicyLimitsUser = 'wallet_approval_policy_limits_user',
  WalletApprovalPolicyApproval = 'wallet_approval_policy_approval',
  WalletApprovalPolicyTransferType = 'wallet_approval_policy_transfer_type',
  WalletApprovalPolicyReview = 'wallet_approval_policy_review',
  WalletApprovalPolicyFinished = 'wallet_approval_policy_finished',
  WalletApprovalPolicyDiscardDraft = 'wallet_approval_policy_discard_draft',
  WalletApprovalPolicyCancelApprovalRequest = 'wallet_approval_policy_cancel_approval_request',
  WalletApprovalPolicyCancelPendingTransaction = 'wallet_approval_policy_cancel_pending_transaction',
  WalletApprovalPolicyApproveApprovalRequest = 'wallet_approval_policy_approve_approval_request',
  WalletApprovalPolicyRejectApprovalRequest = 'wallet_approval_policy_reject_approval_request',
  WalletApprovalSubmittedPolicyProgress = 'wallet_approval_submitted_policy_progress',
  SubscriptionAddConfirmation = 'subscription_add_confirmation',
  ExportReport = 'export_report',
  OnboardingOtherInterest = 'onboarding_other_interest',
  TransferApprovalRequired = 'transfer_approval_required',
  ChooseWalletAndDepositType = 'choose_wallet_and_deposit_type',
  ChooseWalletAndTransferType = 'choose_wallet_and_transfer_type',
  IdentityChallenge = 'show_identity_challenge_instructions',
  OwnershipDisclaimer = 'address_book_add_address_ownership_disclaimer',
  AddNewAddressError = 'address_book_add_address_error',
  ThirdPartyWarning = 'address_book_third_party_warning',
  FxDeposit = 'transfer_fx_deposit',
  FxWithdraw = 'transfer_fx_withdraw',
  FxDepositInstructions = 'transfer_fx_deposit_instructions',
  FxReview = 'transfer_fx_withdraw_review',
  ApprovalRequest = 'address_book_approval_request',
  AceSendOnChainPendingApproval = 'ace_send_onchain_pending_approval',
  AceSendOnChainSend = 'ace_send_onchain_send',
  AceSendOnChainReceive = 'ace_send_onchain_receive',
  AceSendOnChainSuccess = 'ace_send_onchain_success',
  AceSendOnChainFailure = 'ace_send_onchain_failure',
  SettlementAdvanceDepositInstructions = 'settlement_advance_deposit_instructions',
  MsaSign = 'msa_sign',
  MsaSignCrossCurrencySuccess = 'msa_sign_cross_currency_success',
  MsaView = 'msa_view',
}
